export const coachRating = {
  title: "记录比赛",
  opponent: "对手",
  opponentPlaceholder: "搜索 @handle 或姓名…",
  matchType: {
    friendly: "友谊赛",
    ranked: "排位赛",
    tournament: "锦标赛",
  },
  matchTypes: {
    friendly: "友谊赛",
    club: "俱乐部赛",
    tournament: "锦标赛",
  },
  set: "第",
  you: "我",
  addSet: "添加一盘",
  matchResult: "比赛结果",
  victory: "胜利！",
  keepPracticing: "继续加油！",
  saveMatch: "保存比赛",
  saving: "保存中...",
  validation: {
    opponentRequired: "请先选择对手。",
  },
};
